import { Model } from 'pinia-orm';
import Application from './Application';
import TimelineEvent from './TimelineEvent';
import moment from 'moment';
import Document from './Document';

export default class InboundEmail extends Model {

    static get entity () {
        return 'inbound_emails';
    }

    static fields () {
        return {
            id: this.uid(),
            application_id: this.attr(null),
            from: this.attr(''),
            to: this.attr([]),
            cc: this.attr([]),
            subject: this.attr(''),
            message: this.attr(''),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            application: this.belongsTo(Application, 'application_id'),
            documents: this.morphMany(Document, 'attachable_id', 'attachable_type'),
            timeline_event: this.morphOne(TimelineEvent, 'eventable_id', 'eventable_type'),
        }
    }

    get moment () {
        return moment(this.created_at);
    }
}
